import rule from '../../FORMS/namespace/relation/doingEdit_namespace_relation';
export default {
    verb: 'doingEdit',
    namespace: 'security',
    relation: 'profile',
    description: 'Edit the security:profile record.',
    //this is the actual logic:
    logic: rule.logic
};
